// eslint-disable-next-line no-restricted-imports -- pre-existing Immutable usage; migrate off when touched
import { Map } from 'immutable';
import _ from 'lodash';

export const GENERIC_BAD_RESPONSE = 'GENERIC_BAD_RESPONSE';
export function genericErrorAction(error, caughtAction) {
  return {
    type: GENERIC_BAD_RESPONSE,
    error: error,
    caughtAction: caughtAction,
  };
}

export const ERROR_WITH_ALERT = 'ERROR_WITH_ALERT';
export function errorActionWithAlert(error, caughtAction) {
  if (_.has(error, 'errors')) {
    // Throw a still fairly generic error alert.  This is really only meant for admin related requests, as it is still very rough around the edges.
    alert(
      'The following errors were encountered: \n\n' +
        Map(error.errors)
          .map(x => '* ' + x)
          .join('\n'),
    );
  }
  return {
    type: ERROR_WITH_ALERT,
    error: error,
    caughtAction: caughtAction,
  };
}
